var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeRainbow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 26,
    viewBox: "0 0 52 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8128 8.0515C35.6221 8.0515 43.5741 16.0035 43.5741 25.8128H39.0376C39.0376 18.509 33.1166 12.588 25.8128 12.588C18.509 12.588 12.588 18.509 12.588 25.8128H8.0515C8.0515 16.0035 16.0035 8.0515 25.8128 8.0515Z",
    fill: "#FFB584"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8128 0C40.0688 1.2463e-06 51.6256 11.5568 51.6256 25.8128H47.0891C47.0891 14.0622 37.5634 4.53652 25.8128 4.53652C14.0622 4.53652 4.53652 14.0622 4.53652 25.8128H0C1.2463e-06 11.5568 11.5568 -1.2463e-06 25.8128 0Z",
    fill: "#FFB584"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8128 15.737C31.3775 15.737 35.8886 20.2481 35.8886 25.8128H31.3521C31.3521 22.7536 28.8721 20.2735 25.8128 20.2735C22.7536 20.2735 20.2736 22.7536 20.2736 25.8128H15.737C15.737 20.2481 20.2481 15.737 25.8128 15.737Z",
    fill: "#FFB584"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeRainbow);
export default __webpack_public_path__ + "static/media/orange-rainbow.c2e867f3a882791158a0410d9d23f36f.svg";
export { ForwardRef as ReactComponent };